const getters = {
  user: (state) => {
    if (window.isElectron) {
      if (
        window.location.hostname &&
        process.env.VUE_APP_SAAS_WEB_URL.includes(window.location.hostname)
      ) {
        // 这是嵌套的网页
        return state.userInfo.profile;
      }
      return state.user.userInfo;
    } else {
      return state.userInfo.profile;
    }
  },
  isAuthenticated: (state, getters) => {
    console.log(getters.user, "000======");
    return getters.user && !!getters.user.user_id;
  },
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
};
export default getters;
